<template>
    <div class="myPage94">
        <el-drawer :visible.sync="show" @closed="closed" :with-header="false">
            <div class="winBox">
                <div v-if="cartList.length == 0" class="empty">您的购物车是空的</div>
                <div class="closeBtn m_kuoda m_flex m_aic m_jcc" @click="closeWinFun">
                    <img src="@/assets/images/del.png" class="icon" alt="" />
                </div>
                <div v-if="cartList.length > 0" class="topBox m_flex m_aic m_jcsb">
                    <div class="name">购物车({{ cartList.length }})</div>
                </div>
                <div v-if="cartList.length > 0" class="scrollYBox">
                    <div class="itemBox m_flex m_ais m_jcsb" v-for="(item, index) in cartList" :key="index">
                        <div class="delBtnBox m_kuoda" @click="delFun(item, index)">
                            <i class="el-icon-delete closeIcon"></i>
                        </div>
                        <div class="productImg">
                            <img :src="item.image ? item.image : vuex_default_img" class="img" alt="" />
                        </div>
                        <div class="rBox">
                            <div class="title">{{ item.zSn }}</div>
                            <div class="title2">{{ item.title }}</div>
                            <div class="title3">{{ item.subtitle }}</div>
                            <div class="yesFlexBox m_flex m_aic m_jcs">
                                <i class="el-icon-circle-check yesIcon" v-if="item.kucun > 0"></i>
                                <div class="yesText">{{ item.kucun > 0 ? '有货' : '无货' }}</div>
                            </div>
                            <div class="price">¥{{ item.priceSale }}</div>
                            <div class="myInputNumber m_flex m_aic m_jcsb">
                                <el-input-number @change="(e) => numChange(e, item, index)" v-model="item.num" :min="1" :max="9999"></el-input-number>
                                <div class="price2">¥{{ item.allPrice }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="cartList.length > 0" class="bottomBigBox">
                    <div class="titleFlexBox m_flex m_aic m_jcsb">
                        <div class="name">预估订单总额</div>
                        <div class="price">¥{{ price }}</div>
                    </div>
                    <div class="hintText">在结账时将计算包括税费和运费在内的最终总额</div>
                    <div class="redBtn m_flex m_aic m_jcc btn-ripple" @click="queryCartFun">查看购物车</div>
                    <div class="redBtnText" @click="emptyCarFun">清空购物车</div>
                    <!-- <div class="redBtnText nomb">需要报价？了解更多</div> -->
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    data() {
        return {
            cartList: [],
            show: false,
            price: '0.00', // 购物车最下方总价
        }
    },
    computed: {
        ...mapState({
            vuex_cartWin: (state) => state.vuex_cartWin,
        }),
    },
    watch: {
        vuex_cartWin: {
            immediate: true,
            deep: true,
            handler(newV) {
                if (newV) {
                    this.getCarList()
                } else {
                    this.show = false
                }
            },
        },
    },
    created() {},
    mounted() {},
    methods: {
        queryCartFun() {
            this.$router.push({
                path: '/cart',
            })
        },
        closed() {
            this.$store.commit('set_vuex_data', {
                k: 'vuex_cartWin',
                v: false,
            })
        },
        async delFun(item, index) {
            this.$load.open()
            let res = await this.api_gouwuche_del({
                inventoryId: item.inventoryId,
            })
            if (res.code == 200) {
                let userInfo = this.$cloneDeep(this.vuex_userInfo)
                userInfo['cartNum'] = res.data.count
                this.mix_setVuex('vuex_userInfo', userInfo)
                this.getCarList()
            } else {
                this.$load.close(200)
                alertErr(res.msg)
            }
        },
        // 获取购物车列表
        async getCarList() {
            this.$load.open()
            await this.mix_getUserInfo()
            let res = await this.api_gouwuche_lists({})
            this.$load.close()
            if (res.code == 200) {
                this.show = true
                this.cartList = res.data.lists
                this.mathPrice()
            } else {
                alertErr(res.msg)
            }
        },
        // 计算购物车单价和总价
        mathPrice() {
            let price = 0
            this.cartList.forEach((item, index) => {
                item['allPrice'] = this.mix_mathPrice(item['priceSale'], item['num'])
                price += Number(this.mix_mathPrice(item['priceSale'], item['num']))
            })
            this.cartList = this.$cloneDeep(this.cartList)
            this.price = price.toFixed(2)
        },
        async numChange(e, item, index) {
            // 修改购物车数量
            this.$load.open()
            let res = await this.api_gouwuche_updateNum({
                inventoryId: item.inventoryId,
                num: item.num,
            })
            this.$load.close(200)
            if (res.code == 200) {
            } else {
                alertErr(res.msg)
            }
            this.mathPrice()
        },
        closeWinFun() {
            this.$store.commit('set_vuex_data', {
                k: 'vuex_cartWin',
                v: false,
            })
        },
        emptyCarFun() {
            this.$confirm('您确定要删除此购物车及其所有项目吗？', '清空次购物车', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                confirmButtonClass: 'm_confirmButtonClass',
                cancelButtonClass: 'm_cancelButtonClass',
            })
                .then(async () => {
                    this.$load.open()
                    let res = await this.api_gouwuche_delAll({})
                    this.$load.close()
                    if (res.code == 200) {
                        this.cartList = []
                        let userInfo = this.$cloneDeep(this.vuex_userInfo)
                        userInfo['cartNum'] = 0
                        this.mix_setVuex('vuex_userInfo', userInfo)
                    } else {
                        alertErr(res.msg)
                    }
                })
                .catch(() => {})
        },
        api_gouwuche_lists(obj) {
            return new Promise(async (resolve, reject) => {
                this.$api('gouwuche_lists', obj).then((res) => {
                    resolve(res)
                })
            })
        },
        api_gouwuche_del(obj) {
            return new Promise(async (resolve, reject) => {
                this.$api('gouwuche_del', obj).then((res) => {
                    resolve(res)
                })
            })
        },
        api_gouwuche_updateNum(obj) {
            return new Promise(async (resolve, reject) => {
                this.$api('gouwuche_updateNum', obj).then((res) => {
                    resolve(res)
                })
            })
        },
        api_gouwuche_delAll(obj) {
            return new Promise(async (resolve, reject) => {
                this.$api('gouwuche_delAll', obj).then((res) => {
                    resolve(res)
                })
            })
        },
    },
}
</script>

<style lang="less" scoped>
.myPage94 {
    .winBox {
        position: relative;
        width: 100%;
        height: 100%;
        background: #ffffff;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #707070;

        .empty {
            padding: 20px;
        }

        .scrollYBox {
            width: 100%;
            height: calc(100% - 208px - 60px);
            overflow-y: auto;

            .itemBox {
                width: 100%;
                padding: 10px 20px;
                border-bottom: 1px solid lightgray;
                position: relative;

                .delBtnBox {
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    cursor: pointer;
                    z-index: 9;

                    .closeIcon {
                        font-size: 18px;
                    }
                }

                .productImg {
                    width: 60px;
                    height: 60px;
                    background: #ffffff;
                    border-radius: 3px 3px 3px 3px;
                    border: 1px solid #c9c9c9;
                    margin-right: 16px;

                    .img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }

                .rBox {
                    width: calc(100% - 60px - 16px);

                    .title {
                        cursor: pointer;
                        font-weight: bold;
                        font-size: 16px;
                        color: #d61818;
                        line-height: 24px;
                        text-align: left;
                        width: calc(100% - 50px);
                    }

                    .title2 {
                        font-weight: bold;
                        font-size: 14px;
                        color: #000000;
                        line-height: 24px;
                        text-align: left;
                    }

                    .title3 {
                        font-weight: 400;
                        font-size: 12px;
                        color: #000000;
                        line-height: 18px;
                        text-align: left;
                        margin-bottom: 8px;
                    }

                    .yesFlexBox {
                        margin-bottom: 5px;

                        .yesIcon {
                            font-size: 16px;
                            color: #32a365;
                            margin-right: 6px;
                        }

                        .yesText {
                            font-weight: 400;
                            font-size: 12px;
                            color: #000000;
                            line-height: 18px;
                            text-align: left;
                        }
                    }

                    .price {
                        width: 100%;
                        font-weight: bold;
                        font-size: 16px;
                        color: #000000;
                        line-height: 24px;
                        text-align: left;
                        margin-bottom: 15px;
                    }

                    .myInputNumber {
                        :deep .el-input-number {
                            width: 180px;
                        }

                        :deep .el-input-number__decrease:hover {
                            color: #d61818;
                        }

                        :deep .el-input-number__increase:hover {
                            color: #d61818;
                        }

                        :deep .el-input-number__decrease:hover:not(.is-disabled) ~ .el-input .el-input__inner:not(.is-disabled),
                        :deep .el-input-number__increase:hover:not(.is-disabled) ~ .el-input .el-input__inner:not(.is-disabled) {
                            border-color: #d61818;
                        }

                        :deep .el-input.is-active .el-input__inner,
                        :deep .el-input__inner:focus {
                            border-color: #d61818;
                        }

                        .price2 {
                            font-weight: 400;
                            font-size: 14px;
                            color: #000000;
                            line-height: 23px;
                        }
                    }
                }
            }
        }

        .bottomBigBox {
            height: 208px;
            background: #ffffff;
            box-shadow: 0px -6px 6px 1px rgba(0, 0, 0, 0.16);
            border-radius: 0px 0px 0px 0px;
            padding: 18px 33px;
            z-index: 9;

            .titleFlexBox {
                margin-bottom: 10px;

                .name {
                    font-weight: bold;
                    font-size: 16px;
                    color: #000000;
                    line-height: 24px;
                    text-align: left;
                }

                .price {
                    font-weight: bold;
                    font-size: 16px;
                    color: #000000;
                    line-height: 24px;
                    text-align: left;
                }
            }

            .hintText {
                font-weight: 400;
                font-size: 12px;
                color: #949494;
                line-height: 18px;
                text-align: left;
                margin-bottom: 18px;
            }

            .redBtn {
                width: 100%;
                height: 50px;
                background: #d61818;
                border-radius: 5px 5px 5px 5px;
                font-weight: bold;
                font-size: 16px;
                color: #ffffff;
                line-height: 24px;
                text-align: left;
                cursor: pointer;
                margin-bottom: 24px;
            }

            .redBtnText {
                width: 100%;
                font-weight: bold;
                font-size: 16px;
                color: #d61818;
                line-height: 24px;
                text-align: center;
                cursor: pointer;
                margin-bottom: 24px;

                &.nomb {
                    margin-bottom: 0;
                }
            }
        }

        .topBox {
            width: 100%;
            height: 60px;
            padding: 0 22px;
            border-bottom: 1px solid lightgray;

            .name {
                font-weight: 900;
                font-size: 20px;
                color: #000000;
                line-height: 29px;
                text-align: left;
            }
        }
    }

    .closeBtn {
        width: 16px;
        height: 16px;
        cursor: pointer;
        position: absolute;
        top: 20px;
        right: 20px;

        .icon {
            width: 100%;
            height: 100%;
        }
    }
}

@media (max-width: 1199px) {
    .myPage94{
        /deep/.el-drawer{
            width: 100% !important;
        }
    }
}
</style>
